<app-page-header></app-page-header>
<app-breadcromb pageName="Reset Password"></app-breadcromb>
<!-- Login Area Start -->
<section class="jobguru-login-area section_70">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="login-box">
          <div class="login-title">
            <h3>Reset Password</h3>
          </div>
          <form [formGroup]="forgetPasswordForm" (ngSubmit)="sendPasswordResetLink()">
            <div class="single-login-field">
              <input type="email" formControlName="email" placeholder="Email Address">
              <div class="text-danger" *ngIf="f.email.touched && f.email.invalid">
                <span *ngIf="f.email.errors.required">Email is required</span>
              </div>
              <div class="text-danger" *ngIf="f.email.touched && f.email.invalid">
                <span *ngIf="f.email.errors.invalidEmail">Email field should be a valid email</span>
              </div>
            </div>

            <div class="single-login-field">
              <button [disabled]="forgetPasswordForm.invalid" class="btn btn-primary btn-xs" type="submit">
                <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                <span *ngIf="!loading">Send Password Reset Link.</span>
                <span *ngIf="loading">Please wait...</span>
              </button>
              <div *ngIf="error" class="alert alert-danger mt-3 mb-0">{{error}}</div>
              <div *ngIf="success" class="alert alert-success mt-3 mb-0">{{success}}</div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Login Area End -->
